import serviceWorkerService from '@/services/serviceWorkerService';

const NOTIFICATION_MESSAGE_TYPES = {
    REMOVE_NOTIFICATIONS_AND_BADGES: 'REMOVE_NOTIFICATIONS_AND_BADGES',
    UPDATE_BADGES_COUNT: 'UPDATE_BADGES_COUNT',
    REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
};

const postMessageToServiceWorker = (message) => {
    return serviceWorkerService.postMessage(message);
};

const clearAppNotifications = (notificationTypes) => {
    return postMessageToServiceWorker({
        type: NOTIFICATION_MESSAGE_TYPES.REMOVE_NOTIFICATIONS_AND_BADGES,
        notificationTypes,
    });
};

const updateAppBadges = () => {
    return postMessageToServiceWorker({
        type: NOTIFICATION_MESSAGE_TYPES.UPDATE_BADGES_COUNT,
    });
};

const removeNotification = (messageId) => {
    return postMessageToServiceWorker({
        type: NOTIFICATION_MESSAGE_TYPES.REMOVE_NOTIFICATION,
        messageId,
    });
};

export default {
    clearAppNotifications,
    updateAppBadges,
    removeNotification,
    NOTIFICATION_MESSAGE_TYPES,
};
